module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1516-ded37242d296c4e810131923d22591da.png";